import React from 'react'
import Button from './Button'
import Window, { WindowDealProps } from './Window'
import { IsOpen, SetOpen } from './context'

const MakeDeal: React.FC<WindowDealProps> = (props) => {
  const [open, setOpen] = React.useState(false)

  return (
    <IsOpen.Provider value={open}>
      <SetOpen.Provider value={setOpen}>
        <Button />
        <Window {...props} />
      </SetOpen.Provider>
    </IsOpen.Provider>
  )
}

export default MakeDeal
